import { useMemo } from "react";
import { useField } from "../../../api/useField";
import { AGREEMENT_TYPE_LABELS } from "./employmentRun";

// Contract-type labels are managed in Directus (staff_weekly_hours.agreement_type choices) — the CRM must
// show whatever the owner sets there. The hardcoded map only bridges the metadata load.
export const useAgreementTypeLabels = () => {
    const { formatedField } = useField("staff_weekly_hours", "agreement_type");
    const labels = useMemo(() => {
        const choices = formatedField?.settings?.options?.choices ?? [];
        const directusLabels = choices.reduce((labelMap: Record<string, string>, choice) => {
            if (!choice.value || !choice.text) return labelMap;
            return { ...labelMap, [choice.value]: choice.text };
        }, {});
        const mergedLabels = { ...AGREEMENT_TYPE_LABELS, ...directusLabels };
        return mergedLabels;
    }, [formatedField]);
    return labels;
};
